import React, { useEffect, useState, useMemo, useRef } from "react";
import BreadCrumsHeader from "../../common/BreadCrums";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import Checkbox from "../../common/Checkbox";
import SwitchStatus from "../../common/Status";
import Pagination from "../../common/TablePagination";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../common/Loader";
import {
  getAllTargets,
  getFundraisers,
  toggleFundraiserStatus,
  deleteFundraiserById,
  approveOrRejectFundraiser,
} from "../../../services/fundraiserService";
import { deleteFundraiserAdmin } from "../../../services/adminService";
import RejectOfferPopup from "../../common/RejectOfferPopup";
import crossIcon from "../../../Assets/Icons/cross.svg";
import closeIcon from "../../../Assets/Icons/popupCloseIcon.svg";
import whiteTick from "../../../Assets/Icons/White Tick.svg";
import { separateDateTimeAndConvertToLocale } from "../../../utils/utilFunctions";
import { ReactComponent as UncheckedIcon } from "../../../Assets/Icons/uncheckedWhiteBox.svg";
import { ReactComponent as UncheckedGreyIcon } from "../../../Assets/Icons/unCheckedGreyIcon.svg";
import { ReactComponent as ApprovedIcon } from "../../../Assets/Icons/approveIcon.svg";
import { ReactComponent as DeclinedIcon } from "../../../Assets/Icons/declinedIcon.svg";
import { ReactComponent as HourglassIcon } from "../../../Assets/Icons/hourglass.svg";
import DeleteConfirmationModal from "../../common/DeleteConfirmationModal";
import "./fundraiserList.scss";
import SearchBar from "../../common/SearchBar";
import { Dropdown } from "antd";
import { DatePicker } from "antd";
import FilterButton from "../../common/FilterButton";

import toast from "../../../utils/toast";
import FilterPanel from "../../common/FilterPanel";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import { ReactComponent as FiltersIcon } from "../../../Assets/Icons/filtersIcon.svg";
import debounce from "lodash.debounce";
import { getFundraiserById } from "../../../services/fundraiserService";
import DetailsModal from "../../common/DetailsModal";
import TableEmptyState from "../../common/TableEmptyState";
import PopupContent from "./PopupContent";
import CancelPopup from "../../common/CancelPopup";
import ActiveFilterBar from "../../common/ActiveFilterBar";
import { Drawer as MuiDrawer } from "@mui/material";
import deleteImg from "../../../Assets/Icons/deleteIcon.svg";
import { formatCustomDateRangeLabel } from "../../../utils/filterLabelUtils";
import TruncatedTableCell from "../../common/TruncatedTableCell";
import { matchesListDateRange } from "../../../utils/listTimePeriod";

const { RangePicker } = DatePicker;

const FundraiserListDataTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const loading = useSelector((state) => state?.fundraiserReducer?.loading);
  const [isMobileView, setIsMobileView] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false,
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setCount] = useState(0);
  const [statusToggled, setStatusToggled] = useState(false);
  const [selected, setSelected] = useState([]);
  const [showActionModal, setShowActionModal] = useState(false);
  const [customDate, setCustomDate] = useState([null, null]);

  const DURATION_MAP = {
    Today: "DAY",
    "This Week": "WEEK",
    "This Month": "MONTH",
    "This Year": "YEAR",
    "Custom Date": "CUSTOM",
  };
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [filterParams, setFilterParams] = useState({
    status: null,
    duration: null,
    startDate: null,
    endDate: null,
  });
  const [fundraiserDetails, setFundraiserDetails] = useState({});
  const [selectedYear, setSelectedYear] = useState("2025");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [fundraiserToDelete, setFundraiserToDelete] = useState(null);
  const [showBulkDeleteConfirm, setShowBulkDeleteConfirm] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [pendingStatusChange, setPendingStatusChange] = useState(null);
  const [statusChangeLoading, setStatusChangeLoading] = useState(false);
  const statusMutationLockRef = useRef(false);
  const [searching, setSearching] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [fullFundraisersList, setFullFundraisersList] = useState([]);
  const [displayedFundraisers, setDisplayedFundraisers] = useState([]);
  const [manualSortMap, setManualSortMap] = useState(() => {
    try {
      const saved = localStorage.getItem("fundraiserManualSortMap");
      return saved ? JSON.parse(saved) : {};
    } catch {
      return {};
    }
  });
  const pendingFundraiserModalId = location?.state?.openFundraiserId;

  // Persist manual sort map to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(
      "fundraiserManualSortMap",
      JSON.stringify(manualSortMap),
    );
  }, [manualSortMap]);

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [filterData, setFilterData] = useState([
    {
      id: "status",
      title: "Status",
      options: [
        "In-Progress",
        "Pending",
        "Live",
        "Rejected",
        "Disabled",
        "Deleted",
      ],
      defaultValue: "",
      multiSelect: false,
      valueMap: {
        "In-Progress": "in_progress",
        Pending: "pending",
        Live: "approved",
        Rejected: "rejected",
        Disabled: "disabled",
        Deleted: "deleted",
      },
    },
    {
      id: "duration",
      title: "Time Period",
      options: ["Today", "This Week", "This Month", "This Year", "Custom Date"],
      defaultValue: "",
      multiSelect: false,
      valueMap: DURATION_MAP,
      customContent: (selected, filterParams) => {
        console.log("Custom Date selected value:", selected);
        return selected === "Custom Date" ? (
          <div
            className="mt-3 flex flex-col gap-2"
            style={{ pointerEvents: "auto", zIndex: 10000 }}
          >
            <div className="flex flex-col gap-1">
              <label className="text-[12px] font-medium text-gray-600">
                Start Date
              </label>
              <DatePicker
                value={customDate?.[0]}
                onChange={(date) => {
                  console.log("Start date changed:", date);
                  const newDates = [date, customDate?.[1]];
                  setCustomDate(newDates);
                }}
                onClick={(e) => {
                  console.log("DatePicker clicked!", e);
                }}
                style={{ width: "100%", pointerEvents: "auto" }}
                className="custom-date-picker"
                placeholder="Select Start Date"
                format="YYYY-MM-DD"
                showTime={false}
                allowClear={true}
                getPopupContainer={(trigger) => trigger.parentNode}
                popupClassName="date-picker-popup"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[12px] font-medium text-gray-600">
                End Date
              </label>
              <DatePicker
                value={customDate?.[1]}
                onChange={(date) => {
                  console.log("End date changed:", date);
                  const newDates = [customDate?.[0], date];
                  setCustomDate(newDates);
                }}
                onClick={(e) => {
                  console.log("DatePicker clicked!", e);
                }}
                style={{ width: "100%", pointerEvents: "auto" }}
                className="custom-date-picker"
                placeholder="Select End Date"
                format="YYYY-MM-DD"
                showTime={false}
                allowClear={true}
                getPopupContainer={(trigger) => trigger.parentNode}
                popupClassName="date-picker-popup"
              />
            </div>
          </div>
        ) : null;
      },
    },
  ]);

  // Fix: Update filterData when customDate changes to avoid stale closures in customContent
  useEffect(() => {
    setFilterData((prevData) =>
      prevData.map((filter) => {
        if (filter.id === "duration") {
          return {
            ...filter,
            customContent: (selected, filterParams) => {
              console.log("Custom Date selected value:", selected);
              return selected === "Custom Date" ? (
                <div
                  className="mt-3 flex flex-col gap-2"
                  style={{ pointerEvents: "auto", zIndex: 10000 }}
                >
                  <div className="flex flex-col gap-1">
                    <label className="text-[12px] font-medium text-gray-600">
                      Start Date
                    </label>
                    <DatePicker
                      value={customDate?.[0]}
                      onChange={(date) => {
                        console.log("Start date changed:", date);
                        const newDates = [date, customDate?.[1]];
                        setCustomDate(newDates);
                      }}
                      onClick={(e) => {
                        console.log("DatePicker clicked!", e);
                      }}
                      style={{ width: "100%", pointerEvents: "auto" }}
                      className="custom-date-picker"
                      placeholder="Select Start Date"
                      format="YYYY-MM-DD"
                      showTime={false}
                      allowClear={true}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName="date-picker-popup"
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="text-[12px] font-medium text-gray-600">
                      End Date
                    </label>
                    <DatePicker
                      value={customDate?.[1]}
                      onChange={(date) => {
                        console.log("End date changed:", date);
                        const newDates = [customDate?.[0], date];
                        setCustomDate(newDates);
                      }}
                      onClick={(e) => {
                        console.log("DatePicker clicked!", e);
                      }}
                      style={{ width: "100%", pointerEvents: "auto" }}
                      className="custom-date-picker"
                      placeholder="Select End Date"
                      format="YYYY-MM-DD"
                      showTime={false}
                      allowClear={true}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName="date-picker-popup"
                    />
                  </div>
                </div>
              ) : null;
            },
          };
        }
        return filter;
      }),
    );
  }, [customDate]);

  // Create initial state from filter data
  const createInitialState = (filters) => {
    return filters.reduce((acc, filter) => {
      if (filter.multiSelect) {
        // For multi-select, initialize as array
        acc[filter.id] = Array.isArray(filter.defaultValue)
          ? filter.defaultValue
          : [];
      } else {
        // For single select, initialize as single value
        acc[filter.id] = filter.defaultValue;
      }
      return acc;
    }, {});
  };

  // Initialize selections with the initial state
  const [selections, setSelections] = useState(createInitialState(filterData));

  const handleSelectionChange = (filterId, value) => {
    setSelections((prev) => ({
      ...prev,
      [filterId]: value,
    }));

    if (filterId === "duration" && value !== "CUSTOM") {
      setCustomDate([null, null]);
    }
  };

  // Removed old handleReset

  const getFundraisersData = async (
    silent = false,
    ignoreStatus = false,
    filterOverride = null,
  ) => {
    if (silent) setSearching(true);

    try {
      const activeFilters = filterOverride || filterParams;
      const isCustomDuration = activeFilters?.duration === "CUSTOM";
      const requestStartDate =
        isCustomDuration && customDate?.[0]
          ? customDate[0].format("YYYY-MM-DD")
          : activeFilters?.startDate || null;
      const requestEndDate =
        isCustomDuration && customDate?.[1]
          ? customDate[1].format("YYYY-MM-DD")
          : activeFilters?.endDate || null;
      const params = {
        limit: 500,
        ...(activeFilters?.duration && { duration: activeFilters.duration }),
        ...(!ignoreStatus &&
          activeFilters.status && {
            status: activeFilters.status.toLowerCase(),
          }),
        ...(requestStartDate && { startDate: requestStartDate }),
        ...(requestEndDate && { endDate: requestEndDate }),
        silent: silent,
      };

      const response = await dispatch(getFundraisers(params))?.unwrap();
      if (response?.success) {
        setFullFundraisersList(response?.data || []);
      }
    } finally {
      setSearching(false);
    }
  };

  const updatePageSlice = (data, page) => {
    if (!data) return;
    const startIndex = (page - 1) * 10;
    const endIndex = startIndex + 10;
    setDisplayedFundraisers(data.slice(startIndex, endIndex));
  };

  const normalizeSearchValue = (value) =>
    String(value || "")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();

  const normalizeDigits = (value) => String(value || "").replace(/\D/g, "");

  const matchesFundraiserSearch = (fundraiser, searchTerm) => {
    const normalizedTerm = normalizeSearchValue(searchTerm);
    if (!normalizedTerm) return true;

    const digitsOnlyTerm = normalizeDigits(searchTerm);
    const balanceText = String(fundraiser?.balance ?? "0");
    const balanceFormatted = `$${balanceText}`;
    const balanceDigits = normalizeDigits(balanceText);

    const searchableValues = [
      fundraiser?.user?.name,
      fundraiser?.name,
      fundraiser?.user?.email,
      fundraiser?.email,
      fundraiser?.contactPersonNumber,
      fundraiser?.contactNumber,
      fundraiser?.phone,
      balanceText,
      balanceFormatted,
      fundraiser?.status,
    ]
      .filter(Boolean)
      .map((value) => normalizeSearchValue(value));

    if (searchableValues.some((value) => value.includes(normalizedTerm))) {
      return true;
    }

    if (digitsOnlyTerm) {
      const contactDigits = normalizeDigits(
        fundraiser?.contactPersonNumber ||
          fundraiser?.contactNumber ||
          fundraiser?.phone,
      );
      if (contactDigits.includes(digitsOnlyTerm)) return true;
      if (balanceDigits.includes(digitsOnlyTerm)) return true;
    }

    return false;
  };

  // 1. Initial load
  useEffect(() => {
    getFundraisersData();
  }, [statusToggled]);

  // 2. Logic to filter and slice data for display
  useEffect(() => {
    if (!fullFundraisersList) return;

    const filtered = [...fullFundraisersList]
      .filter((fundraiser) =>
        matchesListDateRange(
          fundraiser,
          filterParams.duration === "CUSTOM" ? filterParams.startDate : null,
          filterParams.duration === "CUSTOM" ? filterParams.endDate : null,
          ["createdAt", "created_at"],
        ),
      )
      .filter((fundraiser) => matchesFundraiserSearch(fundraiser, searchQuery));

    setCount(filtered.length);
    setTotalPages(Math.ceil(filtered.length / 10) || 1);

    updatePageSlice(filtered, currentPage);
    setSearching(false);
  }, [fullFundraisersList, currentPage, searchQuery, filterParams]);

  const items = [
    {
      title: "Fundraisers",
    },
    {
      title: "Fundraiser List",
    },
  ];

  const STATUS_BADGE_WIDTH = "110px";

  // Helper function to get status badge configuration - shows formatted status from API
  const getStatusBadgeConfig = (status) => {
    const s = (status || "").toLowerCase();

    // Format: capitalize first letter of each word, replace underscores with spaces
    const formatStatus = (val) => {
      if (!val) return "";
      return val.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    };

    // Map to colors/icons but show formatted status label
    const statusMap = {
      pending: {
        label: formatStatus(status),
        bgColor: "#FFF1D6",
        borderColor: "#FFC961",
        iconColor: "#FFC961",
        width: STATUS_BADGE_WIDTH,
      },
      "in-progress": {
        label: formatStatus(status),
        bgColor: "#FFF1D6",
        borderColor: "#FFC961",
        iconColor: "#FFC961",
        width: STATUS_BADGE_WIDTH,
      },
      "in progress": {
        label: formatStatus(status),
        bgColor: "#FFF1D6",
        borderColor: "#FFC961",
        iconColor: "#FFC961",
        width: STATUS_BADGE_WIDTH,
      },
      in_process: {
        label: formatStatus(status),
        bgColor: "#FFF1D6",
        borderColor: "#FFC961",
        iconColor: "#FFC961",
        width: STATUS_BADGE_WIDTH,
      },
      in_progress: {
        label: formatStatus(status),
        bgColor: "#FFF1D6",
        borderColor: "#FFC961",
        iconColor: "#FFC961",
        width: STATUS_BADGE_WIDTH,
      },
      approved: {
        label: "Live",
        bgColor: "rgba(80, 205, 137, 0.15)",
        borderColor: "#50CD89",
        iconColor: "#50CD89",
        width: STATUS_BADGE_WIDTH,
      },
      live: {
        label: "Live",
        bgColor: "rgba(80, 205, 137, 0.15)",
        borderColor: "#50CD89",
        iconColor: "#50CD89",
        width: STATUS_BADGE_WIDTH,
      },
      declined: {
        label: formatStatus(status),
        bgColor: "rgba(236, 130, 110, 0.15)",
        borderColor: "#EC826E",
        iconColor: "#EC826E",
        width: STATUS_BADGE_WIDTH,
      },
      rejected: {
        label: formatStatus(status),
        bgColor: "rgba(236, 130, 110, 0.15)",
        borderColor: "#EC826E",
        iconColor: "#EC826E",
        width: STATUS_BADGE_WIDTH,
      },
      disabled: {
        label: formatStatus(status),
        bgColor: "rgba(236, 130, 110, 0.15)",
        borderColor: "#EC826E",
        iconColor: "#EC826E",
        width: STATUS_BADGE_WIDTH,
      },
      deleted: {
        label: formatStatus(status),
        bgColor: "rgba(236, 130, 110, 0.15)",
        borderColor: "#EC826E",
        iconColor: "#EC826E",
        width: STATUS_BADGE_WIDTH,
      },
    };

    return (
      statusMap[s] || {
        label: formatStatus(status),
        bgColor: "transparent",
        borderColor: "#FFC961",
        iconColor: "#FFC961",
        width: STATUS_BADGE_WIDTH,
      }
    );
  };

  // Helper function to render status icon
  const renderStatusIcon = (status, size = 12) => {
    const s = (status || "").toLowerCase();

    if (s === "approved" || s === "live") {
      // Checkmark icon for Live
      return (
        <svg
          width={size}
          height={size}
          viewBox="8 6 14 14"
          fill="none"
          style={{ display: "block" }}
        >
          <path
            d="M12 13.6667L14.3333 16L19 11"
            stroke="white"
            strokeWidth="2.0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    } else if (s === "declined" || s === "rejected" || s === "disabled") {
      // Minus icon for Disabled / Rejected
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          style={{ display: "block" }}
        >
          <path d="M7 12h10" />
        </svg>
      );
    } else if (s === "deleted") {
      // X icon for Deleted status
      return (
        <svg
          width={size}
          height={size}
          viewBox="8 6 14 14"
          fill="none"
          style={{ display: "block" }}
        >
          <path
            d="M18 15.8573C18 15.9358 17.9377 16 17.8616 16L16.7197 15.9946L15 13.8811L13.282 15.9929L12.1384 15.9982C12.0623 15.9982 12 15.9358 12 15.8555C12 15.8216 12.0121 15.7895 12.0329 15.7628L14.2837 12.9982L12.0329 10.2354C12.012 10.2093 12.0004 10.1766 12 10.1427C12 10.0642 12.0623 10 12.1384 10L13.282 10.0054L15 12.1189L16.718 10.0071L17.8599 10.0018C17.936 10.0018 17.9983 10.0642 17.9983 10.1445C17.9983 10.1784 17.9862 10.2105 17.9654 10.2372L15.718 13L17.9689 15.7646C17.9896 15.7895 18 15.8234 18 15.8573Z"
            fill="white"
          />
        </svg>
      );
    } else if (s === "pending") {
      return (
        <svg
          width={size + 2}
          height={size + 2}
          viewBox="0 0 16 16"
          fill="none"
          style={{ display: "block" }}
        >
          <circle cx="8" cy="8" r="8" fill="#FFC961" />
          <path
            d="M6.3313 6.0321C6.33139 5.81179 6.38384 5.59472 6.48431 5.39875C6.58478 5.20279 6.73043 5.03352 6.90928 4.90502C7.08813 4.77652 7.29508 4.69236 7.51289 4.65955C7.73069 4.62673 7.9531 4.6462 8.16186 4.71632C8.37061 4.78645 8.55956 4.90521 8.71334 5.06277C8.86713 5.22034 8.98124 5.41227 9.04616 5.6227C9.11108 5.83314 9.12503 6.05583 9.08688 6.27272C9.04874 6.48961 8.95959 6.69411 8.82689 6.86964L8.78282 6.91777C8.76127 6.94091 8.68672 7.01248 8.66255 7.03277C8.62515 7.06429 8.58608 7.09377 8.54548 7.12095L8.04248 7.4673C7.91817 7.55296 7.81658 7.66758 7.74638 7.80128C7.67618 7.93499 7.63949 8.08369 7.63964 8.23496"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="7.63989" cy="10.5802" r="0.7" fill="white" />
        </svg>
      );
    } else if (
      ["in-progress", "in progress", "in_process", "in_progress"].includes(s)
    ) {
      return (
        <HourglassIcon
          width={size}
          height={size + 1}
          style={{ display: "block" }}
        />
      );
    } else {
      // Fallback to pending-style question mark
      return (
        <svg
          width={size + 2}
          height={size + 2}
          viewBox="0 0 16 16"
          fill="none"
          style={{ display: "block" }}
        >
          <circle cx="8" cy="8" r="8" fill="#FFC961" />
          <path
            d="M6.3313 6.0321C6.33139 5.81179 6.38384 5.59472 6.48431 5.39875C6.58478 5.20279 6.73043 5.03352 6.90928 4.90502C7.08813 4.77652 7.29508 4.69236 7.51289 4.65955C7.73069 4.62673 7.9531 4.6462 8.16186 4.71632C8.37061 4.78645 8.55956 4.90521 8.71334 5.06277C8.86713 5.22034 8.98124 5.41227 9.04616 5.6227C9.11108 5.83314 9.12503 6.05583 9.08688 6.27272C9.04874 6.48961 8.95959 6.69411 8.82689 6.86964L8.78282 6.91777C8.76127 6.94091 8.68672 7.01248 8.66255 7.03277C8.62515 7.06429 8.58608 7.09377 8.54548 7.12095L8.04248 7.4673C7.91817 7.55296 7.81658 7.66758 7.74638 7.80128C7.67618 7.93499 7.63949 8.08369 7.63964 8.23496"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="7.63989" cy="10.5802" r="0.7" fill="white" />
        </svg>
      );
    }
  };

  const columns = [
    {
      name: "",
      width: "40px",
    },
    {
      name: "No.",
    },
    {
      name: "Fundraiser Name (Organisation)",
      className: "max-w-[220px]",
      minWidth: "200px",
    },
    {
      name: "Date Joined",
    },
    {
      name: "Email",
    },
    {
      name: "Fundraiser Contact Name",
      className: "max-w-[180px]",
      minWidth: "200px",
    },
    {
      name: "Fundraiser Contact Number",
      className: "max-w-[180px]",
      minWidth: "200px",
    },
    {
      name: "Balance",
    },
    {
      name: "Status",
    },
    {
      name: "Actions",
    },
  ];

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // Scroll to top of fundraiser list when changing pages
    const container = document.getElementById("fundraiser-list-container");
    if (container) {
      container.scrollIntoView({ behavior: "smooth" });
    } else {
      // Fallback to window scroll
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // Allow selecting all fundraisers (any status) to enable moving Approved/Declined back to Pending
  const getSelectableFundraisers = () => {
    return (displayedFundraisers || []).filter((fundraiser) =>
      isSelectable(fundraiser?.status),
    );
  };

  const handleSelectAll = () => {
    const selectableFundraisers = getSelectableFundraisers();
    const selectableIds = selectableFundraisers.map(
      (fundraiser) => fundraiser._id || fundraiser.id,
    );
    const areAllSelectableIdsSelected =
      selectableIds.length > 0 &&
      selectableIds.every((id) => selected.includes(id));

    if (areAllSelectableIdsSelected) {
      setSelected((prev) => prev.filter((id) => !selectableIds.includes(id)));
    } else {
      setSelected((prev) => Array.from(new Set([...prev, ...selectableIds])));
    }
  };

  const handleSelectOne = (event, id, status) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selected, id];
    } else {
      newSelected = selected.filter((selectedId) => selectedId !== id);
    }

    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // All statuses selectable
  const isSelectable = (status) => {
    const normalized = (status || "").toLowerCase();
    return (
      normalized !== "deleted" &&
      ![
        "in-progress",
        "in progress",
        "in_process",
        "in process",
        "in_progress",
      ].includes(normalized)
    );
  };

  const handleBulkApprove = async () => {
    try {
      const payload = { ids: selected, status: "live" };
      const res = await dispatch(approveOrRejectFundraiser(payload))?.unwrap();
      if (res?.success === true) {
        const timestamp = Date.now();
        const newSortMap = { ...manualSortMap };
        selected.forEach((id) => {
          newSortMap[String(id)] = timestamp;
        });
        setManualSortMap(newSortMap);
        setFullFundraisersList((prev) =>
          prev.map((f) =>
            selected.includes(f._id || f.id) ? { ...f, status: "live" } : f,
          ),
        );
        setSelected([]);
        setShowActionModal(false);
        setCurrentPage(1);
        setStatusToggled(!statusToggled);
        try {
          toast.success("Fundraiser(s) approved successfully");
        } catch (_) {}
      }
    } catch (_) {}
  };

  const handleBulkDecline = async () => {
    // Open modal to capture reason, then submit via submitBulkDecline
    setBulkDeclineReason("");
    setBulkDeclineMode("declined");
    setShowBulkDeclineModal(true);
  };

  const handleBulkDisable = async () => {
    if (selected.length === 0) return;
    try {
      const payload = { ids: selected, status: "disabled" };
      const res = await dispatch(approveOrRejectFundraiser(payload))?.unwrap();
      if (res?.success) {
        const timestamp = Date.now();
        const newSortMap = { ...manualSortMap };
        selected.forEach((id) => {
          newSortMap[String(id)] = timestamp;
        });
        setManualSortMap(newSortMap);
        setFullFundraisersList((prev) =>
          prev.map((f) =>
            selected.includes(f._id || f.id) ? { ...f, status: "disabled" } : f,
          ),
        );
        setSelected([]);
        setShowActionModal(false);
        setCurrentPage(1);
        setStatusToggled(!statusToggled);
        try {
          toast.success("Fundraiser(s) disabled successfully");
        } catch (_) {}
      }
    } catch (_) {}
  };

  const handleBulkDelete = () => {
    setShowBulkDeleteConfirm(true);
  };

  // --- Bulk Decline Modal State/Handlers ---
  const [showBulkDeclineModal, setShowBulkDeclineModal] = useState(false);
  const [bulkDeclineReason, setBulkDeclineReason] = useState("");
  const [bulkDeclineMode, setBulkDeclineMode] = useState("declined");

  const closeBulkDeclineModal = () => {
    setShowBulkDeclineModal(false);
    setBulkDeclineReason("");
    setBulkDeclineMode("declined");
  };

  const submitBulkDecline = async () => {
    const trimmed = (bulkDeclineReason || "").trim();
    if (!trimmed || selected.length === 0) return;
    try {
      const payload = { ids: selected, status: "declined", reason: trimmed };
      const res = await dispatch(approveOrRejectFundraiser(payload))?.unwrap();
      if (res?.success) {
        const timestamp = Date.now();
        const newSortMap = { ...manualSortMap };
        selected.forEach((id) => {
          newSortMap[String(id)] = timestamp;
        });
        setManualSortMap(newSortMap);
        const nextStatus = "declined";
        setFullFundraisersList((prev) =>
          prev.map((f) =>
            selected.includes(f._id || f.id) ? { ...f, status: nextStatus } : f,
          ),
        );
        setSelected([]);
        setShowActionModal(false);
        setCurrentPage(1);
        setStatusToggled(!statusToggled);
        closeBulkDeclineModal();
        try {
          toast.success("Fundraiser(s) declined successfully");
        } catch (_) {}
      }
    } catch (_) {}
  };

  const closeBulkDeleteConfirm = () => {
    setShowBulkDeleteConfirm(false);
  };

  const handleBulkDeleteConfirm = async () => {
    if (selected.length === 0) return;
    try {
      const results = await Promise.all(
        selected.map((id) => dispatch(deleteFundraiserAdmin({ id }))?.unwrap()),
      );
      if (results.length > 0) {
        setSelected([]);
        setShowActionModal(false);
        setStatusToggled(!statusToggled);
        setShowBulkDeleteConfirm(false);
        getFundraisersData(true, false);
        toast.success("Fundraiser(s) deleted successfully!");
      }
    } catch (error) {
      console.error("Error deleting fundraiser(s):", error);
      toast.error("Failed to delete fundraiser(s).");
    }
  };

  useEffect(() => {
    if (selected.length > 0) {
      setShowActionModal(true);
    } else {
      setShowActionModal(false);
    }
  }, [selected]);

  const activeFilterChips = useMemo(() => {
    const chips = [];
    Object.entries(filterParams).forEach(([key, value]) => {
      if (
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0)
      )
        return;
      if (value === "") return;

      const filter = filterData.find((f) => f.id === key);
      if (!filter) return;

      if (filter.multiSelect && Array.isArray(value)) {
        value.forEach((val) => {
          const displayLabel =
            Object.keys(filter.valueMap || {}).find(
              (k) => filter.valueMap[k] === val,
            ) || val;
          chips.push({ id: key, value: val, label: `${displayLabel}` });
        });
      } else {
        const displayLabel =
          Object.keys(filter.valueMap || {}).find(
            (k) => filter.valueMap[k] === value,
          ) || value;
        chips.push({ id: key, value: value, label: `${displayLabel}` });
      }
    });

    // Special handling for custom date range label
    if (filterParams.duration === "CUSTOM") {
      const dChip = chips.find((c) => c.id === "duration");
      if (dChip) {
        dChip.label = formatCustomDateRangeLabel(
          filterParams.startDate || customDate?.[0],
          filterParams.endDate || customDate?.[1],
        );
      }
    }

    return chips;
  }, [filterParams, filterData, customDate]);

  const activeCount = activeFilterChips.length;
  const isFundraiserCustomDateIncomplete =
    selections?.duration === "Custom Date" &&
    (!customDate?.[0] || !customDate?.[1]);
  const shouldShowSelectionControls = activeCount > 0;

  const applyFilters = (sels) => {
    const mappedFilterParams = {
      status: null,
      duration: null,
      startDate: null,
      endDate: null,
    };

    filterData.forEach((filter) => {
      const selectedValue = sels[filter.id];
      if (
        selectedValue !== null &&
        selectedValue !== undefined &&
        selectedValue !== "" &&
        !(Array.isArray(selectedValue) && selectedValue.length === 0)
      ) {
        if (filter.id === "duration" && selectedValue === "CUSTOM") {
          mappedFilterParams.duration = "CUSTOM";
          if (customDate && (customDate[0] || customDate[1])) {
            mappedFilterParams.startDate = customDate[0]
              ? customDate[0].format("YYYY-MM-DD")
              : null;
            mappedFilterParams.endDate = customDate[1]
              ? customDate[1].format("YYYY-MM-DD")
              : null;
          }
        } else if (filter.valueMap) {
          mappedFilterParams[filter.id] = filter.multiSelect
            ? selectedValue.map((val) => filter.valueMap[val])
            : filter.valueMap[selectedValue];
        } else {
          mappedFilterParams[filter.id] = selectedValue;
        }
      }
    });

    setFilterParams(mappedFilterParams);
    setCurrentPage(1);
    return mappedFilterParams;
  };

  const handleApply = () => {
    const mappedFilterParams = applyFilters(selections);
    getFundraisersData(false, false, mappedFilterParams);
    setOpen(false);
  };

  const handleReset = () => {
    const initialState = createInitialState(filterData);
    const clearedFilterParams = {
      status: null,
      duration: null,
      startDate: null,
      endDate: null,
    };
    setSelections(initialState);
    setFilterParams(clearedFilterParams);
    setCustomDate([null, null]);
    setSearchInput("");
    setSearchQuery("");
    setCurrentPage(1);
    setSelected([]);
    getFundraisersData(false, false, clearedFilterParams);
  };

  const handleRemoveFilter = (targetChip) => {
    const filter = filterData.find((f) => f.id === targetChip.id);
    if (!filter) return;

    let newValue;
    if (filter.multiSelect) {
      newValue = selections[targetChip.id].filter(
        (v) => v !== targetChip.value,
      );
    } else {
      newValue = null;
    }

    const newSelections = { ...selections, [targetChip.id]: newValue };
    setSelections(newSelections);

    if (targetChip.id === "duration" && newValue === null) {
      setCustomDate([null, null]);
    }

    const mappedFilterParams = applyFilters(newSelections);
    getFundraisersData(false, false, mappedFilterParams);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((query) => {
        setSearchQuery(query);
      }, 500),
    [],
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSearchChange = (value) => {
    setSearchInput(value);
    setCurrentPage(1);
    debouncedSearch(value);
  };

  const fetchFundraiserDetails = async (fundraiserId) => {
    try {
      const result = await dispatch(
        getFundraiserById({ id: fundraiserId, silent: true }),
      )?.unwrap();
      if (result?.success) {
        // `prev` can be `null` right after openPopup() sets it; spread must be guarded.
        setFundraiserDetails((prev) => ({ ...(prev || {}), ...result.data }));
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchTargets = async (fundraiserId, year) => {
    try {
      const result = await dispatch(
        getAllTargets({ id: fundraiserId, year, silent: true }),
      )?.unwrap();
      if (result?.success) {
        setFundraiserDetails((prev) => ({
          ...(prev || {}),
          target: result.data,
        }));
      }
    } catch (e) {
      console.error(e);
    }
  };

  const openPopup = async (fundraiserId) => {
    setFundraiserDetails(null);
    setIsDetailOpen(true);
    fetchFundraiserDetails(fundraiserId);
    fetchTargets(fundraiserId, selectedYear);
  };

  useEffect(() => {
    if (!pendingFundraiserModalId) return;

    openPopup(pendingFundraiserModalId);
    navigate(location.pathname, { replace: true, state: {} });
  }, [pendingFundraiserModalId, navigate, location.pathname]);

  const closePopup = () => {
    setSelectedYear("2025");
    setFundraiserDetails(null);
    setIsDetailOpen(false);
  };

  const handleYearChange = (fundraiserId, dateString) => {
    setSelectedYear(dateString);
    fetchTargets(fundraiserId, dateString);
  };

  const handleDeleteFundraiser = (id) => {
    setFundraiserToDelete(id);
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const deletePromise = await dispatch(
        deleteFundraiserById({ id: fundraiserToDelete }),
      )?.unwrap();
      if (deletePromise?.success === true) {
        setIsDetailOpen(false);
        getFundraisersData(true, false);
        toast.success("Fundraiser deleted successfully!");
      }
    } catch (error) {
      console.error("Error deleting fundraiser:", error);
      toast.error("Failed to delete fundraiser.");
    } finally {
      setShowDeleteConfirm(false);
      setFundraiserToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirm(false);
    setFundraiserToDelete(null);
  };

  const handleShowReviewModal = () => {
    setShowReviewModal(true);
  };

  const handleCloseReviewModal = () => {
    if (statusChangeLoading) return;
    setShowReviewModal(false);
    setPendingStatusChange(null);
  };

  const getStatusChangeCopy = (statusKey) => {
    const s = String(statusKey || "").toLowerCase();

    if (s === "approved" || s === "live") {
      return {
        heading: "Change Status",
        content: "Are you sure you want to make this fundraiser Live?",
      };
    }

    if (s === "pending") {
      return {
        heading: "Change Status",
        content:
          "Are you sure you want to move this fundraiser back to In-Progress?",
      };
    }

    if (s === "disabled") {
      return {
        heading: "Change Status",
        content: "Are you sure you want to disable this fundraiser?",
      };
    }

    if (s === "rejected" || s === "declined") {
      return {
        heading: "Change Status",
        content: "Are you sure you want to reject this fundraiser?",
      };
    }

    if (s === "deleted") {
      return {
        heading: "Delete Fundraiser",
        content:
          "Are you sure you want to delete this fundraiser? This action cannot be undone.",
      };
    }

    return {
      heading: "Change Status",
      content: "Are you sure you want to change this fundraiser status?",
    };
  };

  const openStatusChangeModal = (fundraiserId, newStatus) => {
    if (
      !fundraiserId ||
      !newStatus ||
      statusChangeLoading ||
      statusMutationLockRef.current
    )
      return;
    setPendingStatusChange({ fundraiserId, newStatus });
    setShowReviewModal(true);
  };

  const confirmStatusChange = async () => {
    if (
      !pendingStatusChange ||
      statusChangeLoading ||
      statusMutationLockRef.current
    )
      return;

    const { fundraiserId, newStatus } = pendingStatusChange;
    const normalizedStatus = String(newStatus || "").toLowerCase();
    const apiStatus =
      normalizedStatus === "live" ? "approved" : normalizedStatus;

    statusMutationLockRef.current = true;
    setStatusChangeLoading(true);
    try {
      const payload = { ids: [fundraiserId], status: apiStatus };
      const statusPromise = await dispatch(
        approveOrRejectFundraiser(payload),
      )?.unwrap();
      if (statusPromise?.success === true) {
        const nextStatus = apiStatus;
        setManualSortMap((prev) => ({
          ...prev,
          [String(fundraiserId)]: Date.now(),
        }));
        setFullFundraisersList((prev) =>
          prev.map((f) =>
            f._id === fundraiserId || f.id === fundraiserId
              ? { ...f, status: nextStatus }
              : f,
          ),
        );
        setCurrentPage(1);
        setStatusToggled(!statusToggled);
        setIsDetailOpen(false);
        setShowReviewModal(false);
        setPendingStatusChange(null);
        setFundraiserDetails((prev) =>
          prev && (prev._id === fundraiserId || prev.id === fundraiserId)
            ? { ...prev, status: nextStatus }
            : prev,
        );
        const statusLabel =
          nextStatus === "approved" || nextStatus === "live"
            ? "Live"
            : nextStatus === "disabled"
              ? "Disabled"
              : nextStatus === "pending"
                ? "In-Progress"
                : nextStatus === "deleted"
                  ? "Deleted"
                  : nextStatus;
        toast.success(
          `Fundraiser status changed to ${statusLabel} successfully!`,
        );
      }
    } catch (e) {
      console.error("Error reviewing fundraiser status:", e);
      toast.error(`Failed to change fundraiser status to ${newStatus}.`);
    } finally {
      setStatusChangeLoading(false);
      statusMutationLockRef.current = false;
    }
  };

  // Decline flow using themed modal and closing details first
  const [showFundraiserDecline, setShowFundraiserDecline] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [declineTargetId, setDeclineTargetId] = useState(null);
  const [declineTargetStatus, setDeclineTargetStatus] = useState("rejected");
  const [declineModalContent, setDeclineModalContent] = useState(
    "Please provide a reason for declining this fundraiser. Your reason will be emailed to the fundraiser contact.",
  );
  const [statusDropdownOpenId, setStatusDropdownOpenId] = useState(null);
  const toggleStatusDropdown = (fundraiserId, disabled) => {
    if (
      disabled ||
      !fundraiserId ||
      statusChangeLoading ||
      statusMutationLockRef.current
    )
      return;
    setStatusDropdownOpenId((currentOpenId) =>
      currentOpenId === fundraiserId ? null : fundraiserId,
    );
  };

  const openDeclineModal = (fundraiserId, targetStatus = "rejected") => {
    if (statusChangeLoading || statusMutationLockRef.current) return;
    setIsDetailOpen(false); // hide details while decline modal is open
    setDeclineTargetId(fundraiserId);
    setDeclineTargetStatus(targetStatus);
    setDeclineReason("");
    setDeclineModalContent(
      targetStatus === "disabled"
        ? "Please provide a reason for disabling this fundraiser. Your reason will be emailed to the fundraiser contact."
        : "Please provide a reason for declining this fundraiser. Your reason will be emailed to the fundraiser contact.",
    );
    setShowFundraiserDecline(true);
    return true;
  };

  const closeDeclineModal = (success = false) => {
    setShowFundraiserDecline(false);
    setDeclineReason("");
    setDeclineTargetId(null);
    setDeclineTargetStatus("rejected");
    setDeclineModalContent(
      "Please provide a reason for declining this fundraiser. Your reason will be emailed to the fundraiser contact.",
    );
    // Reopen the details modal only if it wasn't a success (cancel case)
    if (!success) {
      setIsDetailOpen(true);
    }
  };

  const submitDecline = async () => {
    const trimmed = (declineReason || "").trim();
    if (
      !trimmed ||
      !declineTargetId ||
      statusChangeLoading ||
      statusMutationLockRef.current
    )
      return;
    statusMutationLockRef.current = true;
    setStatusChangeLoading(true);
    try {
      const apiStatus =
        declineTargetStatus === "disabled" ? "disabled" : "rejected";
      const payload = {
        ids: [declineTargetId],
        status: apiStatus,
        reason: trimmed,
      };
      const resp = await dispatch(approveOrRejectFundraiser(payload))?.unwrap();
      if (resp?.success) {
        const fundraiserId = declineTargetId;
        setManualSortMap((prev) => ({
          ...prev,
          [String(fundraiserId)]: Date.now(),
        }));
        const nextStatus =
          declineTargetStatus === "disabled" ? "disabled" : "rejected";
        setFullFundraisersList((prev) =>
          prev.map((f) =>
            f._id === fundraiserId || f.id === fundraiserId
              ? { ...f, status: nextStatus }
              : f,
          ),
        );
        setFundraiserDetails((prev) => ({
          ...(prev || {}),
          status: nextStatus,
        }));
        setStatusToggled(!statusToggled);
        closeDeclineModal(true); // pass true for success
        setIsDetailOpen(false); // explicitly close detail modal
        toast.success(
          `Fundraiser ${nextStatus === "disabled" ? "disabled" : "rejected"} successfully`,
        );
      }
    } catch (_) {
      toast.error(
        `Failed to ${declineTargetStatus === "disabled" ? "disable" : "reject"} fundraiser.`,
      );
    } finally {
      setStatusChangeLoading(false);
      statusMutationLockRef.current = false;
    }
  };

  const handleApproveSingle = async (fundraiserId) => {
    if (!fundraiserId || statusChangeLoading || statusMutationLockRef.current)
      return false;
    statusMutationLockRef.current = true;
    setStatusChangeLoading(true);
    try {
      const payload = { ids: [fundraiserId], status: "live" };
      const res = await dispatch(approveOrRejectFundraiser(payload))?.unwrap();
      if (res?.success === true) {
        setManualSortMap((prev) => ({
          ...prev,
          [String(fundraiserId)]: Date.now(),
        }));
        setFullFundraisersList((prev) =>
          prev.map((f) =>
            f._id === fundraiserId || f.id === fundraiserId
              ? { ...f, status: "live" }
              : f,
          ),
        );
        setCurrentPage(1);
        setStatusToggled(!statusToggled);
        setIsDetailOpen(false); // Close the modal
        toast.success("Fundraiser approved successfully");
        return true;
      }
    } catch (_) {
      toast.error("Failed to approve fundraiser.");
    } finally {
      setStatusChangeLoading(false);
      statusMutationLockRef.current = false;
    }
    return false;
  };

  const handleReviewStatus = async (fundraiserId, newStatus) => {
    openStatusChangeModal(fundraiserId, newStatus);
  };

  // Calculate count of selectable items for "Select All" checkbox
  const selectableFundraisersOnPage = getSelectableFundraisers();
  const selectableIdsOnPage = selectableFundraisersOnPage.map(
    (fundraiser) => fundraiser._id || fundraiser.id,
  );
  const selectableCount = selectableIdsOnPage.length;
  const allSelectableSelected =
    selectableCount > 0 &&
    selectableIdsOnPage.every((id) => selected.includes(id));

  // Determine which bulk action buttons to show based on selected statuses
  const selectedStatuses = selected
    .map(
      (id) =>
        fullFundraisersList?.find((f) => f._id === id || f.id === id)?.status,
    )
    .filter(Boolean)
    .map((s) => s?.toLowerCase());

  // In-Progress states (can be approved or rejected)
  const inProgressStates = [
    "pending",
    "in-process",
    "in progress",
    "in-progress",
    "in_process",
    "in_progress",
  ];
  const hasPendingSelected = selectedStatuses.some((status) =>
    inProgressStates.includes(status),
  );

  // Approved/Live/Rejected/Disabled states
  const hasLiveOrApprovedSelected = selectedStatuses.some(
    (status) => status === "approved" || status === "live",
  );
  const hasLiveSelected = hasLiveOrApprovedSelected;
  const hasRejectedSelected = selectedStatuses.some(
    (status) => status === "rejected" || status === "declined",
  );
  const hasDisabledSelected = selectedStatuses.some(
    (status) => status === "disabled",
  );

  // Show approve/reject buttons only if there are in-progress items selected
  const showApproveDecline = selected.length > 0 && hasPendingSelected;
  const showLiveActions = selected.length > 0 && hasLiveSelected;
  const showRejectedActions = selected.length > 0 && hasRejectedSelected;
  const showDisabledActions = selected.length > 0 && hasDisabledSelected;

  useEffect(() => {
    if (!shouldShowSelectionControls && selected.length > 0) {
      setSelected([]);
    }
  }, [shouldShowSelectionControls, selected]);

  return (
    <>
      {loading === true && <Loader />}
      {isDetailOpen && (
        <DetailsModal
          handleClose={closePopup}
          content={
            <PopupContent
              merchantDetails={fundraiserDetails}
              setSelectedYear={setSelectedYear}
              selectedYear={selectedYear}
              handleYearChange={handleYearChange}
              onShowReviewModal={handleShowReviewModal}
              onDecline={openDeclineModal}
              onApprove={handleApproveSingle}
              onDelete={handleDeleteFundraiser}
              onStatusChange={(newStatus) => {
                const fundraiserId = fundraiserDetails?._id;
                if (!fundraiserId) return;
                setFundraiserDetails((prev) => ({
                  ...(prev || {}),
                  status: newStatus,
                }));
                setManualSortMap((prev) => ({
                  ...prev,
                  [String(fundraiserId)]: Date.now(),
                }));
                setFullFundraisersList((prev) =>
                  prev.map((f) =>
                    f._id === fundraiserId || f.id === fundraiserId
                      ? { ...f, status: newStatus }
                      : f,
                  ),
                );
                setCurrentPage(1);
                setStatusToggled(!statusToggled);
                setIsDetailOpen(false);
                setFundraiserDetails(null);
              }}
            />
          }
          popupClassName="p-6 w-[335px] sm:w-[600px] md:w-[800px]"
        />
      )}
      {showFundraiserDecline && (
        <RejectOfferPopup
          handleClose={closeDeclineModal}
          content={declineModalContent}
          popupClassName={"w-[335px] sm:w-[470px] pb-4"}
          setReason={setDeclineReason}
          handleOfferRejection={submitDecline}
          showCloseIcon={true}
          loading={statusChangeLoading}
        />
      )}
      {showDeleteConfirm && (
        <DeleteConfirmationModal
          isOpen={showDeleteConfirm}
          onClose={handleDeleteCancel}
          onConfirm={handleDeleteConfirm}
          itemName="Fundraiser"
        />
      )}
      <div className="flex flex-col sm:flex-row justify-between col-span-12 gap-4">
        <BreadCrumsHeader heading="Fundraiser List" items={items} />
      </div>

      <div className="w-full flex justify-between items-center mt-6 gap-3">
        <SearchBar
          parentDivClass="w-full sm:w-[60%] md:w-[40%] lg:w-[35%] xl:w-[30%]"
          divClassName="relative w-full"
          inputClassName="searchBar w-full p-3 pr-10 text-[14px] font-poppins font-[400] outline-none rounded-[5px] border border-[#D9D9D9] focus:border-[#00ADEF]"
          iconClassName="absolute right-[10px] top-1/2 -translate-y-1/2 w-[22px] h-[22px]"
          placeholder="Search"
          value={searchInput}
          handleChange={(e) => handleSearchChange(e.target.value)}
          onClear={() => handleSearchChange("")}
          loading={searching}
        />
        <div className="flex items-center gap-2">
          <FilterButton
            activeCount={activeCount}
            activeFilterCount={activeCount}
            isOpen={open}
            onClick={() => setOpen(true)}
          />
        </div>
        <MuiDrawer
          anchor="right"
          open={open}
          onClose={() => setOpen(false)}
          ModalProps={{ keepMounted: true }}
          TransitionComponent={Slide}
          SlideProps={{
            appear: true,
            timeout: { enter: 700, exit: 500 },
            easing: {
              enter: "cubic-bezier(0.22, 1, 0.36, 1)",
              exit: "cubic-bezier(0.4, 0, 0.2, 1)",
            },
          }}
          PaperProps={{
            sx: {
              width: { xs: "85%", sm: "400px" },
              padding: "0",
              height: "100%",
            },
          }}
        >
          <FilterPanel
            filterData={filterData}
            selections={selections}
            appliedSelections={filterParams}
            handleApply={handleApply}
            handleCancel={handleCancel}
            handleReset={handleReset}
            handleSelectionChange={handleSelectionChange}
            applyDisabled={isFundraiserCustomDateIncomplete}
            style={{ maxHeight: "unset" }}
          />
        </MuiDrawer>
      </div>

      <ActiveFilterBar
        chips={activeFilterChips}
        onRemove={handleRemoveFilter}
        onClearAll={handleReset}
      />

      <div id="fundraiser-list-container" className="col-span-12 mt-4 relative">
        {/* Desktop Table */}
        <TableContainer
          style={{ width: "100%", overflowX: "auto" }}
          className="hidden md:block"
        >
          <Table
            sx={{
              minWidth: "800px",
              borderCollapse: "separate",
              borderSpacing: "0px 8px",
            }}
            aria-label="simple table"
          >
            <TableHead className="bg-[#00ADEF]">
              <TableRow
                className="h-[50px]"
                sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                {shouldShowSelectionControls && (
                  <TableCell className="!border-b-0">
                    {selectableCount > 0 && (
                      <Checkbox
                        checked={allSelectableSelected}
                        onChecked={handleSelectAll}
                        divClassName="flex items-center"
                        UncheckedIcon={UncheckedIcon}
                        checkClassName={"!w-[22px] !h-[22px]"}
                      />
                    )}
                  </TableCell>
                )}
                {columns.slice(1).map((column) => {
                  const isSpecial = [
                    "Fundraiser Name (Organisation)",
                    "Fundraiser Contact Name",
                    "Fundraiser Contact Number"
                  ].includes(column.name);

                  if (isSpecial) {
                    return (
                      <TableCell
                        key={column.name}
                        className={`!text-[#FFFFFF] !font-[700] ${column.className || ""}`.trim()}
                        title={column.name}
                        style={{
                          padding: "8px 10px",
                          lineHeight: "1.2",
                          verticalAlign: "middle",
                          minWidth: column.minWidth,
                        }}
                      >
                        <span
                          className="font-poppins text-[14px] !text-[#FFFFFF] !font-[700]"
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                          }}
                        >
                          {column.name === "Fundraiser Name (Organisation)" ? (
                            <>
                              Fundraiser Name
                              <br />
                              (Organisation)
                            </>
                          ) : (
                            column.name
                          )}
                        </span>
                      </TableCell>
                    );
                  }

                  return (
                    <TruncatedTableCell
                      key={column.name}
                      className="!text-[#FFFFFF]"
                      textClassName="!text-[#FFFFFF] !font-[700]"
                      title={column.name}
                      maxChars={14}
                    >
                      {column.name}
                    </TruncatedTableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {displayedFundraisers &&
                displayedFundraisers?.length > 0 &&
                displayedFundraisers?.map((fundraiser, index) => {
                  const isItemSelected = isSelected(fundraiser._id);
                  const itemSelectable = isSelectable(fundraiser.status);

                  return (
                    <TableRow
                      key={fundraiser._id}
                      className="h-[50px]"
                      sx={{
                        boxShadow: "0px 4px 4px 0px #00000040",
                        backgroundColor:
                          (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                      }}
                    >
                      {shouldShowSelectionControls && (
                        <TableCell>
                          {itemSelectable && (
                            <Checkbox
                              checked={isItemSelected}
                              onChecked={(event) =>
                                handleSelectOne(
                                  event,
                                  fundraiser._id,
                                  fundraiser.status,
                                )
                              }
                              divClassName="flex items-center"
                              checkClassName="!w-[22px] !h-[22px]"
                            />
                          )}
                        </TableCell>
                      )}
                      <TruncatedTableCell className="max-w-[60px]">
                        {(currentPage - 1) * 10 + index + 1}
                      </TruncatedTableCell>
                      <TruncatedTableCell
                        className="max-w-[220px]"
                        style={{ minWidth: "200px" }}
                      >
                        {fundraiser?.organisationName ||
                          fundraiser?.organizationName ||
                          "N/A"}
                      </TruncatedTableCell>
                      <TruncatedTableCell
                        className="max-w-[120px]"
                        title={fundraiser?.createdAt}
                      >
                        {separateDateTimeAndConvertToLocale(
                          fundraiser?.createdAt,
                        )?.localDate || "N/A"}
                      </TruncatedTableCell>
                      <TruncatedTableCell className="max-w-[180px]">
                        {fundraiser?.user?.email || fundraiser?.email || "N/A"}
                      </TruncatedTableCell>
                      <TruncatedTableCell
                        className="max-w-[180px]"
                        style={{ minWidth: "200px" }}
                      >
                        {fundraiser?.contactPersonName || "N/A"}
                      </TruncatedTableCell>
                      <TruncatedTableCell
                        className="max-w-[180px]"
                        style={{ minWidth: "200px" }}
                      >
                        {fundraiser?.contactPersonNumber || "N/A"}
                      </TruncatedTableCell>
                      <TruncatedTableCell className="max-w-[120px]">{`$${fundraiser?.balance || "0"}`}</TruncatedTableCell>
                      <TableCell className="max-w-[110px]">
                        <div style={{ marginLeft: "-8px" }}>
                          {(() => {
                            const config = getStatusBadgeConfig(
                              fundraiser?.status,
                            );
                            const statusLower = (
                              fundraiser?.status || ""
                            ).toLowerCase();
                            const isDeleted = statusLower === "deleted";
                            const isLive =
                              statusLower === "live" ||
                              statusLower === "approved";
                            const isRejected =
                              statusLower === "rejected" ||
                              statusLower === "declined";
                            const isPending = statusLower === "pending";
                            const isDisabled = statusLower === "disabled";

                            return (
                              <Dropdown
                                menu={{
                                  items: [
                                    // Live status shows: Disabled, Deleted
                                    isLive && {
                                      key: "disabled",
                                      label: (
                                        <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                          <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                            {renderStatusIcon("disabled", 10)}
                                          </div>
                                          <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                            Disable
                                          </span>
                                        </div>
                                      ),
                                      onClick: () =>
                                        handleReviewStatus(
                                          fundraiser._id,
                                          "disabled",
                                        ),
                                    },
                                    isLive && {
                                      key: "deleted",
                                      label: (
                                        <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                          <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                            {renderStatusIcon("deleted", 10)}
                                          </div>
                                          <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                            Delete
                                          </span>
                                        </div>
                                      ),
                                      onClick: () =>
                                        handleDeleteFundraiser(fundraiser._id),
                                    },
                                    // Rejected status shows: Live, Disabled, Deleted
                                    isRejected && {
                                      key: "approved",
                                      label: (
                                        <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                          <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#50CD89]">
                                            {renderStatusIcon("approved", 10)}
                                          </div>
                                          <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                            Live
                                          </span>
                                        </div>
                                      ),
                                      onClick: () =>
                                        handleReviewStatus(
                                          fundraiser._id,
                                          "approved",
                                        ),
                                    },
                                    isRejected && {
                                      key: "disabled",
                                      label: (
                                        <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                          <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                            {renderStatusIcon("disabled", 10)}
                                          </div>
                                          <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                            Disable
                                          </span>
                                        </div>
                                      ),
                                      onClick: () =>
                                        handleReviewStatus(
                                          fundraiser._id,
                                          "disabled",
                                        ),
                                    },
                                    isRejected && {
                                      key: "deleted",
                                      label: (
                                        <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                          <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                            {renderStatusIcon("deleted", 10)}
                                          </div>
                                          <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                            Delete
                                          </span>
                                        </div>
                                      ),
                                      onClick: () =>
                                        handleDeleteFundraiser(fundraiser._id),
                                    },
                                    // Pending status shows: Live, Rejected
                                    isPending && {
                                      key: "approved",
                                      label: (
                                        <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                          <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#50CD89]">
                                            {renderStatusIcon("approved", 10)}
                                          </div>
                                          <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                            Live
                                          </span>
                                        </div>
                                      ),
                                      onClick: () =>
                                        handleReviewStatus(
                                          fundraiser._id,
                                          "approved",
                                        ),
                                    },
                                    isPending && {
                                      key: "rejected",
                                      label: (
                                        <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                          <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                            {renderStatusIcon("rejected", 10)}
                                          </div>
                                          <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                            Reject
                                          </span>
                                        </div>
                                      ),
                                      onClick: () =>
                                        openDeclineModal(fundraiser._id),
                                    },
                                    // Disabled status shows: Live, Deleted
                                    isDisabled && {
                                      key: "approved",
                                      label: (
                                        <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                          <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#50CD89]">
                                            {renderStatusIcon("approved", 10)}
                                          </div>
                                          <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                            Live
                                          </span>
                                        </div>
                                      ),
                                      onClick: () =>
                                        handleReviewStatus(
                                          fundraiser._id,
                                          "approved",
                                        ),
                                    },
                                    isDisabled && {
                                      key: "deleted",
                                      label: (
                                        <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                                          <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                            {renderStatusIcon("deleted", 10)}
                                          </div>
                                          <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                            Delete
                                          </span>
                                        </div>
                                      ),
                                      onClick: () =>
                                        handleDeleteFundraiser(fundraiser._id),
                                    },
                                    // Deleted status shows nothing
                                  ].filter(Boolean),
                                }}
                                trigger={["click"]}
                                placement="bottomLeft"
                                disabled={
                                  isDeleted ||
                                  [
                                    "in-progress",
                                    "in progress",
                                    "in_process",
                                    "in_progress",
                                  ].includes(
                                    (fundraiser?.status || "").toLowerCase(),
                                  ) ||
                                  statusChangeLoading ||
                                  statusMutationLockRef.current
                                }
                                open={
                                  statusDropdownOpenId ===
                                  (fundraiser._id || fundraiser.id)
                                }
                                onOpenChange={(nextOpen) =>
                                  setStatusDropdownOpenId(
                                    nextOpen
                                      ? fundraiser._id || fundraiser.id
                                      : null,
                                  )
                                }
                              >
                                <span className="inline-flex">
                                  <Tooltip
                                    title={
                                      statusDropdownOpenId ===
                                      (fundraiser._id || fundraiser.id)
                                        ? null
                                        : config.label
                                    }
                                    arrow
                                    placement="top"
                                  >
                                    <div
                                      className="flex items-center h-[26px] pl-2.5 pr-2 rounded-full border-[0.5px] select-none"
                                      style={{
                                        backgroundColor: config.bgColor,
                                        borderColor: config.borderColor,
                                        width: config.width,
                                        cursor:
                                          isDeleted ||
                                          [
                                            "in-progress",
                                            "in progress",
                                            "in_process",
                                            "in_progress",
                                          ].includes(
                                            (
                                              fundraiser?.status || ""
                                            ).toLowerCase(),
                                          ) ||
                                          statusChangeLoading ||
                                          statusMutationLockRef.current
                                            ? "not-allowed"
                                            : "pointer",
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        toggleStatusDropdown(
                                          fundraiser._id || fundraiser.id,
                                          isDeleted ||
                                            [
                                              "in-progress",
                                              "in progress",
                                              "in_process",
                                              "in_progress",
                                            ].includes(
                                              (
                                                fundraiser?.status || ""
                                              ).toLowerCase(),
                                            ) ||
                                            statusChangeLoading ||
                                            statusMutationLockRef.current,
                                        );
                                      }}
                                    >
                                      <div
                                        className="flex items-center justify-center w-[16px] h-[16px] rounded-full flex-shrink-0"
                                        style={{
                                          backgroundColor: (() => {
                                            const s = (
                                              fundraiser?.status || ""
                                            ).toLowerCase();
                                            if (
                                              s === "approved" ||
                                              s === "live"
                                            )
                                              return "#50CD89";
                                            if (
                                              s === "declined" ||
                                              s === "rejected" ||
                                              s === "disabled" ||
                                              s === "deleted"
                                            )
                                              return "#EC826E";
                                            return "transparent"; // Remove yellow circle for pending/in-progress
                                          })(),
                                        }}
                                      >
                                        {renderStatusIcon(
                                          fundraiser?.status,
                                          12,
                                        )}
                                      </div>
                                      <span className="text-[12px] font-[400] ml-2 font-poppins text-[#303033] truncate flex-1">
                                        {config.label}
                                      </span>
                                      {!isDeleted &&
                                        ![
                                          "in-progress",
                                          "in progress",
                                          "in_process",
                                          "in_progress",
                                        ].includes(
                                          (
                                            fundraiser?.status || ""
                                          ).toLowerCase(),
                                        ) &&
                                        !statusChangeLoading &&
                                        !statusMutationLockRef.current && (
                                          <div className="ml-2 flex items-center flex-shrink-0">
                                            <svg
                                              width="7"
                                              height="4"
                                              viewBox="0 0 10 6"
                                              fill="none"
                                            >
                                              <path
                                                d="M1 1.5L5 5.5L9 1.5"
                                                stroke="#303033"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          </div>
                                        )}
                                    </div>
                                  </Tooltip>
                                </span>
                              </Dropdown>
                            );
                          })()}
                        </div>
                      </TableCell>
                      <TableCell>
                        <button
                          className={`inline-flex justify-center items-center border rounded-[6px] p-3 h-[34px] border-[#00ADEF] text-[#00ADEF] whitespace-nowrap`}
                          onClick={() => openPopup(fundraiser?._id)}
                        >
                          <span className="font-[600] text-[14px] font-poppins leading-[22px] whitespace-nowrap">
                            View Details
                          </span>
                        </button>
                      </TableCell>
                    </TableRow>
                  );
                })}

              {!loading &&
                !searching &&
                displayedFundraisers &&
                displayedFundraisers.length === 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      align="center"
                      className="!border-b-0 !p-0"
                    >
                      <TableEmptyState itemName="Fundraiser" />
                    </TableCell>
                  </TableRow>
                )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Mobile Card View */}
        <div className="block md:hidden space-y-4">
          {displayedFundraisers &&
            displayedFundraisers?.length > 0 &&
            displayedFundraisers?.map((fundraiser, index) => (
              <div
                key={fundraiser._id}
                className="bg-white rounded-[10px] p-4 border border-[#E0E0E0] shadow-sm flex flex-col gap-3"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="text-[16px] font-[600] text-[#303030] font-poppins truncate max-w-[200px]">
                      {fundraiser?.user?.name || fundraiser?.name || "N/A"}
                    </h3>
                    <p className="text-[12px] font-[400] text-[#767676] font-poppins">
                      {fundraiser?.user?.email || fundraiser?.email || "N/A"}
                    </p>
                  </div>
                  <div>
                    {(() => {
                      const statusLower = (
                        fundraiser?.status || ""
                      ).toLowerCase();
                      const isDeleted = statusLower === "deleted";
                      const isLive =
                        statusLower === "live" || statusLower === "approved";
                      const isRejected =
                        statusLower === "rejected" ||
                        statusLower === "declined";
                      const isPending = statusLower === "pending";
                      const isDisabled = statusLower === "disabled";
                      const isStatusDropdownDisabled =
                        isDeleted ||
                        [
                          "in-progress",
                          "in progress",
                          "in_process",
                          "in_progress",
                        ].includes(statusLower) ||
                        statusChangeLoading ||
                        statusMutationLockRef.current;
                      const config = getStatusBadgeConfig(fundraiser?.status);

                      const menuItems = [
                        isLive && {
                          key: "disabled",
                          label: (
                            <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                              <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                {renderStatusIcon("disabled", 10)}
                              </div>
                              <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                Disable
                              </span>
                            </div>
                          ),
                          onClick: () =>
                            handleReviewStatus(fundraiser._id, "disabled"),
                        },
                        isLive && {
                          key: "deleted",
                          label: (
                            <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                              <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                {renderStatusIcon("deleted", 10)}
                              </div>
                              <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                Delete
                              </span>
                            </div>
                          ),
                          onClick: () => handleDeleteFundraiser(fundraiser._id),
                        },
                        isRejected && {
                          key: "approved",
                          label: (
                            <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                              <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#50CD89]">
                                {renderStatusIcon("approved", 10)}
                              </div>
                              <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                Live
                              </span>
                            </div>
                          ),
                          onClick: () =>
                            handleReviewStatus(fundraiser._id, "approved"),
                        },
                        isRejected && {
                          key: "disabled",
                          label: (
                            <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                              <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                {renderStatusIcon("disabled", 10)}
                              </div>
                              <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                Disable
                              </span>
                            </div>
                          ),
                          onClick: () =>
                            handleReviewStatus(fundraiser._id, "disabled"),
                        },
                        isRejected && {
                          key: "deleted",
                          label: (
                            <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                              <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                {renderStatusIcon("deleted", 10)}
                              </div>
                              <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                Delete
                              </span>
                            </div>
                          ),
                          onClick: () => handleDeleteFundraiser(fundraiser._id),
                        },
                        isPending && {
                          key: "approved",
                          label: (
                            <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                              <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#50CD89]">
                                {renderStatusIcon("approved", 10)}
                              </div>
                              <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                Live
                              </span>
                            </div>
                          ),
                          onClick: () =>
                            handleReviewStatus(fundraiser._id, "approved"),
                        },
                        isPending && {
                          key: "rejected",
                          label: (
                            <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                              <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                {renderStatusIcon("rejected", 10)}
                              </div>
                              <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                Reject
                              </span>
                            </div>
                          ),
                          onClick: () => openDeclineModal(fundraiser._id),
                        },
                        isDisabled && {
                          key: "approved",
                          label: (
                            <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                              <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#50CD89]">
                                {renderStatusIcon("approved", 10)}
                              </div>
                              <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                Live
                              </span>
                            </div>
                          ),
                          onClick: () =>
                            handleReviewStatus(fundraiser._id, "approved"),
                        },
                        isDisabled && {
                          key: "deleted",
                          label: (
                            <div className="flex items-center gap-2 pr-6 pl-1 py-1">
                              <div className="flex items-center justify-center w-[16px] h-[16px] rounded-full bg-[#EC826E]">
                                {renderStatusIcon("deleted", 10)}
                              </div>
                              <span className="text-[13px] font-[400] font-poppins text-[#303033]">
                                Delete
                              </span>
                            </div>
                          ),
                          onClick: () => handleDeleteFundraiser(fundraiser._id),
                        },
                      ].filter(Boolean);

                      if (!isMobileView) {
                        return (
                          <div className="inline-flex">
                            <div
                              className="flex items-center h-[26px] pl-2.5 pr-2 rounded-full border-[0.5px] select-none"
                              style={{
                                backgroundColor: config.bgColor,
                                borderColor: config.borderColor,
                                width: config.width,
                              }}
                            >
                              <div
                                className="flex items-center justify-center w-[16px] h-[16px] rounded-full flex-shrink-0"
                                style={{
                                  backgroundColor: (() => {
                                    const s = (
                                      fundraiser?.status || ""
                                    ).toLowerCase();
                                    if (s === "approved" || s === "live")
                                      return "#50CD89";
                                    if (
                                      s === "declined" ||
                                      s === "rejected" ||
                                      s === "disabled" ||
                                      s === "deleted"
                                    )
                                      return "#EC826E";
                                    return "transparent";
                                  })(),
                                }}
                              >
                                {renderStatusIcon(fundraiser?.status, 10)}
                              </div>
                              <span className="text-[12px] font-[400] ml-2 font-poppins text-[#303033] truncate flex-1 capitalize">
                                {config.label}
                              </span>
                            </div>
                          </div>
                        );
                      }

                      return (
                        <Dropdown
                          menu={{ items: menuItems }}
                          trigger={["click"]}
                          placement="bottomLeft"
                          disabled={isStatusDropdownDisabled}
                          open={
                            statusDropdownOpenId ===
                            (fundraiser._id || fundraiser.id)
                          }
                          onOpenChange={(nextOpen) =>
                            setStatusDropdownOpenId(
                              nextOpen ? fundraiser._id || fundraiser.id : null,
                            )
                          }
                          getPopupContainer={() => document.body}
                        >
                          <span className="inline-flex">
                            <Tooltip
                              title={
                                statusDropdownOpenId ===
                                (fundraiser._id || fundraiser.id)
                                  ? null
                                  : config.label
                              }
                              arrow
                              placement="top"
                            >
                              <div
                                className="flex items-center h-[26px] pl-2.5 pr-2 rounded-full border-[0.5px] select-none"
                                style={{
                                  backgroundColor: config.bgColor,
                                  borderColor: config.borderColor,
                                  width: config.width,
                                  cursor: isStatusDropdownDisabled
                                    ? "not-allowed"
                                    : "pointer",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  toggleStatusDropdown(
                                    fundraiser._id || fundraiser.id,
                                    isStatusDropdownDisabled,
                                  );
                                }}
                              >
                                <div
                                  className="flex items-center justify-center w-[16px] h-[16px] rounded-full flex-shrink-0"
                                  style={{
                                    backgroundColor: (() => {
                                      const s = (
                                        fundraiser?.status || ""
                                      ).toLowerCase();
                                      if (s === "approved" || s === "live")
                                        return "#50CD89";
                                      if (
                                        s === "declined" ||
                                        s === "rejected" ||
                                        s === "disabled" ||
                                        s === "deleted"
                                      )
                                        return "#EC826E";
                                      return "transparent";
                                    })(),
                                  }}
                                >
                                  {renderStatusIcon(fundraiser?.status, 10)}
                                </div>
                                <span className="text-[12px] font-[400] ml-2 font-poppins text-[#303033] truncate flex-1 capitalize">
                                  {config.label}
                                </span>
                                {!isDeleted &&
                                  ![
                                    "in-progress",
                                    "in progress",
                                    "in_process",
                                    "in_progress",
                                  ].includes(statusLower) && (
                                    <div className="ml-2 flex items-center flex-shrink-0">
                                      <svg
                                        width="7"
                                        height="4"
                                        viewBox="0 0 10 6"
                                        fill="none"
                                      >
                                        <path
                                          d="M1 1.5L5 5.5L9 1.5"
                                          stroke="#303033"
                                          strokeWidth="1.8"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </div>
                                  )}
                              </div>
                            </Tooltip>
                          </span>
                        </Dropdown>
                      );
                    })()}
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2 text-[13px] font-poppins text-[#303030]">
                  <div className="flex flex-col">
                    <span className="text-[#8C8C8C] text-[11px]">
                      Joined Date
                    </span>
                    <span className="truncate">
                      {separateDateTimeAndConvertToLocale(fundraiser?.createdAt)
                        ?.localDate || "N/A"}
                    </span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[#8C8C8C] text-[11px]">Contact</span>
                    <span className="truncate">
                      {fundraiser?.contactPersonNumber || "N/A"}
                    </span>
                  </div>
                  <div className="flex flex-col col-span-2 mt-1">
                    <span className="text-[#8C8C8C] text-[11px]">Balance</span>
                    <span className="truncate font-[600] text-[#00ADEF]">
                      {"$" + (fundraiser?.balance || "0")}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-2 mt-2">
                  <button
                    className="flex-1 flex justify-center items-center border border-[#00ADEF] rounded-[6px] py-2 bg-[#F0FBFF] hover:bg-[#E0F7FA] transition-colors"
                    onClick={() => openPopup(fundraiser?._id)}
                  >
                    <span className="font-[600] text-[13px] text-[#00ADEF] font-poppins">
                      View Details
                    </span>
                  </button>
                </div>
              </div>
            ))}
          {!loading &&
            !searching &&
            (!displayedFundraisers || displayedFundraisers.length === 0) && (
              <TableEmptyState itemName="Fundraiser" />
            )}
        </div>

        {displayedFundraisers && displayedFundraisers.length > 0 && (
          <Pagination
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        )}

        {/* Action Modal */}
        {shouldShowSelectionControls && showActionModal && (
          <div
            className="fixed bottom-16 left-[57%] transform -translate-x-1/2 bg-white rounded-[6px] px-4 h-[60px] flex items-center gap-4 z-50 text-[14px] font-[600] text-[#303030] border border-[#0000001A]"
            style={{ boxShadow: "0px 4px 20px 0px #00000029" }}
          >
            <div className="flex items-center gap-2">
              <span className="!text-[12px] !font-[500] !text-[#000000] border border-[#2A35484D] rounded-[4px] w-[24px] h-[24px] flex items-center justify-center">
                {selected.length}
              </span>
              <span className="!font-[500]">Selected</span>
            </div>
            <div className="flex items-center gap-16">
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <Checkbox
                    checked={allSelectableSelected}
                    onChecked={handleSelectAll}
                    divClassName="flex items-center"
                    UncheckedIcon={UncheckedGreyIcon}
                    checkClassName={"!w-[22px] !h-[22px]"}
                  />
                  <span className="whitespace-nowrap !font-[500]">
                    Select All
                  </span>
                </div>
                {showApproveDecline && (
                  <>
                    <button
                      onClick={handleBulkApprove}
                      className={`border border-[#50CD89] text-[#50CD89] h-[38px] min-w-[152px] px-6 py-1 rounded-[6px] whitespace-nowrap flex items-center justify-center text-[13px] font-[600] leading-none transition-colors duration-200 hover:bg-[#EEFBF4] hover:border-[#35B56B] hover:text-[#35B56B] ${selected.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                      disabled={selected.length === 0}
                    >
                      Move to Live
                    </button>
                    <button
                      onClick={handleBulkDecline}
                      className={`border border-[#EC826E] text-[#EC826E] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap transition-colors duration-200 hover:bg-[#FFF1EE] hover:border-[#E65D4A] hover:text-[#E65D4A] ${selected.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                      disabled={selected.length === 0}
                    >
                      Move to Rejected
                    </button>
                  </>
                )}
                {showLiveActions && (
                  <>
                    <button
                      onClick={handleBulkDisable}
                      className={`border border-[#EC826E] text-[#EC826E] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap transition-colors duration-200 hover:bg-[#FFF1EE] hover:border-[#E65D4A] hover:text-[#E65D4A] ${selected.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                      disabled={selected.length === 0}
                    >
                      Disable
                    </button>
                    <button
                      onClick={handleBulkDelete}
                      className={`border border-[#EC826E] text-[#EC826E] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap transition-colors duration-200 hover:bg-[#FFF1EE] hover:border-[#E65D4A] hover:text-[#E65D4A] ${selected.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                      disabled={selected.length === 0}
                    >
                      Delete
                    </button>
                  </>
                )}
                {showRejectedActions && (
                  <>
                    <button
                      onClick={handleBulkApprove}
                      className={`border border-[#50CD89] text-[#50CD89] h-[38px] min-w-[152px] px-6 py-1 rounded-[6px] whitespace-nowrap text-[13px] font-[600] leading-none transition-colors duration-200 hover:bg-[#EEFBF4] hover:border-[#35B56B] hover:text-[#35B56B] ${selected.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                      disabled={selected.length === 0}
                    >
                      Move to Live
                    </button>
                    <button
                      onClick={handleBulkDisable}
                      className={`border border-[#EC826E] text-[#EC826E] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap transition-colors duration-200 hover:bg-[#FFF1EE] hover:border-[#E65D4A] hover:text-[#E65D4A] ${selected.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                      disabled={selected.length === 0}
                    >
                      Disable
                    </button>
                    <button
                      onClick={handleBulkDelete}
                      className={`border border-[#EC826E] text-[#EC826E] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap transition-colors duration-200 hover:bg-[#FFF1EE] hover:border-[#E65D4A] hover:text-[#E65D4A] ${selected.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                      disabled={selected.length === 0}
                    >
                      Delete
                    </button>
                  </>
                )}
                {showDisabledActions && (
                  <>
                    <button
                      onClick={handleBulkApprove}
                      className={`border border-[#50CD89] text-[#50CD89] h-[38px] min-w-[152px] px-6 py-1 rounded-[6px] whitespace-nowrap text-[13px] font-[600] leading-none transition-colors duration-200 hover:bg-[#EEFBF4] hover:border-[#35B56B] hover:text-[#35B56B] ${selected.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                      disabled={selected.length === 0}
                    >
                      Move to Live
                    </button>
                    <button
                      onClick={handleBulkDelete}
                      className={`border border-[#EC826E] text-[#EC826E] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap transition-colors duration-200 hover:bg-[#FFF1EE] hover:border-[#E65D4A] hover:text-[#E65D4A] ${selected.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
                      disabled={selected.length === 0}
                    >
                      Delete
                    </button>
                  </>
                )}
              </div>
              <button
                onClick={() => setSelected([])}
                className="w-[10px] h-[10px]"
              >
                <img src={closeIcon} alt="Close" className="w-full h-full" />
              </button>
            </div>
          </div>
        )}

        {/* Review Status Modal */}
        {showReviewModal && (
          <CancelPopup
            handleNo={handleCloseReviewModal}
            handleYes={confirmStatusChange}
            heading={
              getStatusChangeCopy(
                pendingStatusChange?.newStatus || fundraiserDetails?.status,
              ).heading
            }
            content={
              getStatusChangeCopy(
                pendingStatusChange?.newStatus || fundraiserDetails?.status,
              ).content
            }
            confirmation={
              (pendingStatusChange?.newStatus || fundraiserDetails?.status) ===
                "approved" ||
              (pendingStatusChange?.newStatus || fundraiserDetails?.status) ===
                "live"
            }
            popupClassName="w-[335px] sm:w-[470px] h-[255px] sm:h-[245px]"
            confirmDisabled={statusChangeLoading}
            cancelDisabled={statusChangeLoading}
            confirmLabel={statusChangeLoading ? "Updating..." : "Confirm"}
          />
        )}

        {showBulkDeclineModal && (
          <RejectOfferPopup
            handleClose={closeBulkDeclineModal}
            content={
              bulkDeclineMode === "disabled"
                ? "Please provide a reason for disabling the selected fundraiser(s)."
                : "Please provide a reason for declining the selected fundraiser(s)."
            }
            popupClassName={"w-[335px] sm:w-[470px] pb-4"}
            setReason={setBulkDeclineReason}
            handleOfferRejection={submitBulkDecline}
            showCloseIcon={true}
            loading={statusChangeLoading}
          />
        )}

        {showBulkDeleteConfirm && (
          <DeleteConfirmationModal
            isOpen={showBulkDeleteConfirm}
            onClose={closeBulkDeleteConfirm}
            onConfirm={handleBulkDeleteConfirm}
            itemName="Fundraisers"
            customMessage="Are you sure you want to delete the selected fundraisers? This action cannot be undone."
          />
        )}
      </div>
    </>
  );
};

export default FundraiserListDataTable;
